// @ts-nocheck -- legacy receiving contracts are migrated incrementally below.
import React from "react";

import { formatDate } from "../../../../shared/utility";
import OperationalDataTableSkeleton from "../../../../components/operational/OperationalDataTableSkeleton";

export default function InvoiceRecordAssemblyOptions(props) {
  const { fetchInvoiceDetailsClicked, loading, receivingIndex } = props;
  const rows = receivingIndex?.data || [];

  return (
    <section className="overflow-hidden rounded-[18px] border border-[#E2E8F0] bg-white shadow-[0_1px_2px_rgba(15,23,42,0.04)]">
      <div className="border-b border-[#E2E8F0] px-5 py-4">
        <h2 className="text-base font-semibold text-[#0F172A]">
          Matching received items
        </h2>
        <p className="mt-1 text-sm text-[#64748B]">
          Select an item to load its product and receiving details.
        </p>
      </div>

      {loading ? (
        <OperationalDataTableSkeleton
          columns={["Date", "Supplier", "Invoice", "Manufacturer", "Product"]}
          rows={6}
        />
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full border-separate border-spacing-0 text-sm">
            <thead>
              <tr>
                {["Date", "Supplier", "Invoice", "Manufacturer", "Product"].map(
                  (column) => (
                    <th
                      key={column}
                      scope="col"
                      className="border-b border-[#E2E8F0] bg-[#EFF6FF] px-3 py-3 text-left text-[11px] font-semibold uppercase tracking-[0.08em] text-[#64748B]"
                    >
                      {column}
                    </th>
                  ),
                )}
              </tr>
            </thead>
            <tbody className="bg-white">
              {rows.length > 0 ? (
                rows.map((row) => (
                  <tr
                    key={row.id}
                    className="cursor-pointer transition hover:bg-[#F6F8FB]"
                    onClick={() =>
                      fetchInvoiceDetailsClicked(row.receiving_assembly_item_id)
                    }
                  >
                    <td className="border-b border-[#E2E8F0]/70 px-3 py-3 text-sm text-[#64748B]">
                      {formatDate(row.created_at)}
                    </td>
                    <td className="border-b border-[#E2E8F0]/70 px-3 py-3 text-sm font-semibold text-[#0F172A]">
                      {row.supplier_name || "—"}
                    </td>
                    <td className="border-b border-[#E2E8F0]/70 px-3 py-3 text-sm text-[#64748B]">
                      {row.invoice_number || "—"}
                    </td>
                    <td className="border-b border-[#E2E8F0]/70 px-3 py-3 text-sm text-[#64748B]">
                      {row.manufacturer_name || "—"}
                    </td>
                    <td className="border-b border-[#E2E8F0]/70 px-3 py-3 text-sm text-[#64748B]">
                      {row.product_name || "—"}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan={5}
                    className="px-5 py-14 text-center text-sm text-[#64748B]"
                  >
                    Search to find receiving records.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
